export function hasPayoutMethod(state: Store.State) {
  return !!state.user.payout.method;
}